import { render, staticRenderFns } from "./main.vue?vue&type=template&id=188ecf6a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=188ecf6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ecf6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('188ecf6a')) {
      api.createRecord('188ecf6a', component.options)
    } else {
      api.reload('188ecf6a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=188ecf6a&scoped=true", function () {
      api.rerender('188ecf6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/documents/popup/condition-rule/main.vue"
export default component.exports